"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeTaskqueue_en_us = void 0;
function backofficeTaskqueue_en_us() {
    return {
        "backoffice.taskqueue.title": "Task Queue",
        "backoffice.taskqueue.subtitle": "Overview of tasks like data exports or workflows which are handled as background tasks.",
        "backoffice.taskqueue.start": "Start time",
        "backoffice.taskqueue.owner": "Triggered by",
        "backoffice.taskqueue.type": "Type",
        "backoffice.taskqueue.status": "State",
        "backoffice.taskqueue.payload": "Information",
        "backoffice.taskqueue.nopayload": "No detail infos found",
        "backoffice.taskqueue.statushistory": "Status history",
        "backoffice.taskqueue.source": "Datasource",
        "backoffice.taskqueue.conversion": "Conversion",
        "backoffice.taskqueue.recipient": "Recipient",
        "backoffice.taskqueue.method": "Method",
        "backoffice.taskqueue.url": "URL"
    };
}
exports.backofficeTaskqueue_en_us = backofficeTaskqueue_en_us;
